<template>
  <div class="container">
    <AudioIcon />
    <h3 class="title">{{ title }}</h3>
    <div class="text-wrapper">
      <div class="wrapper">
        <img src="@game/Level04/assets/img/blackmail.png" alt="" class="blackmail-img">
        <p class="blackmail-text">{{ blackmailText }}</p>
        <img src="@game/Level04/assets/img/locky.png" alt="" class="locky-img">
        <div class="locky-container">
          <h4 class="locky-title">{{ lockyTitle }}</h4>
          <p>{{ lockyText }}</p>
        </div>
      </div>
      <div class="button" @click="onClick">{{ buttonText }}</div>
    </div>
  </div>
</template>

<script>
import { tLevel4 } from '@game/utils';
import { audioMixinLevel42 } from '@game/mixins/audioMixin.js';

export default {
  name: 'Scene6',
  mixins: [audioMixinLevel42],
  data() {
    return {
      title: tLevel4('scene6.title'),
      blackmailText: tLevel4('scene6.blackmailText'),
      lockyTitle: tLevel4('scene6.lockyTitle'),
      lockyText: tLevel4('scene6.lockyText'),
      buttonText: tLevel4('scene6.buttonText'),
    }
  },
  methods: {
    onClick() {
      this.$audioManager.playButtonNext(() => {
        this.$router.push({ name: 'L4Scene7' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  /* animation */
  position: absolute;

  width: 100%;
  height: 100%;
  background-image: url(@game/Level04/assets/img/kepu.jpg);
  background-size: cover;
  background-repeat: no-repeat;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h3,
  h4,
  p,
  img {
    margin: 0;
    padding: 0;
  }

  .title {
    position: absolute;
    top: 3%;
    box-sizing: border-box;
    padding: 5px 15px;
    border: .2rem solid #fff;
    border-radius: 1.2rem;
    background: #66a261;
    color: #fff;
    font-weight: normal;
  }

  .text-wrapper {
    box-sizing: border-box;
    width: 70%;
    position: absolute;
    top: 15%;
    bottom: 15%;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .wrapper {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      gap: .5rem;
      width: 100%;

      .blackmail-img {
        height: 5rem;
      }

      .locky-img {
        height: 6rem;
      }

      .blackmail-text,
      .locky-container {
        width: 100%;
      }

      .locky-container {
        h4 {
          font-weight: normal;
          color: #6aa465;
        }
      }
    }

    .button {
      margin-top: 1rem;
      background-color: #66a261;
      color: #fff;
      border-radius: .5rem;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>